import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Tabs from 'antd/lib/tabs';
import notification from 'antd/lib/notification';
import Button from 'antd/lib/button';
import Affix from 'antd/lib/affix';
import Tooltip from 'antd/lib/tooltip';
import Input from 'antd/lib/input';
import Switch from 'antd/lib/switch';
import Divider from 'antd/lib/divider';
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown';
import Popover from 'antd/lib/popover';

import { useCtx } from 'one-ui-provider';

import {
  Sider,
  Header,
  Footer,
  Layout,
  Content,
  ContentBox,
} from 'one-ui-layout';

import {
  HeaderBar, TopNavigation, NavigationItem,
  UserNavigation, UserNavigationItem,
  FooterBox, FooterAsideItem
} from 'one-ui-header';

import {
  //SourceCard,
  AddNewFormEnable,
  SourceCardSimple
} from 'one-card-source';

import {
  CallInfoCard
} from 'one-card-call-info';

import {
  CallDestinationCard
} from 'one-card-call-destination';

import {
  SubjectCard
} from 'one-card-subject';

import logo from "./logo.png";

import {
  UpcomingAppointmentCard,
} from 'one-card-upcoming-appointments';

import {
  PendingBillsCard
} from 'one-card-pending-bills';

import {
  UniphoreDispositionCard
} from 'one-card-uniphore-disposition'

import {
  UniphoreLiveChat
} from 'one-card-uniphore-live-chat';

import {
  UniphoreLiveAssist
} from 'one-card-uniphore-assist';

import {
  PendingReferalsCard,
  ReferralsTab
} from 'one-card-pending-referrals';

import {
  PatientCareProviderCard
} from 'one-card-pcp';

import {
  Notification as NotifyCard
} from 'one-card-notification';

import {
  PatientAdditionalInfoCard
} from 'one-card-patient-additional-info';

import {
  EmergencyContactCard
} from 'one-card-emergency-contact'

import {
  Copyright
} from 'one-card-copyright';

import {
  setSelectedAction,
  addAction as addSubjectAction
} from 'one-state-subject/src/actions';

import {
  CallSelection
} from 'one-simulator';

import {
  CallDestCard
} from 'one-card-calldest';

import {
  EmploymentInfoCard
} from 'one-card-employment-info'

import {
  PharmaciesCard
} from "one-card-patient-pharmacy";

import {
  selectAction,
  addAction as addSourceAction
} from 'one-state-source-local';

import {
  setAction as setTabAction
} from 'one-state-tabs';

import {
  ScreenPopFrom,
  ScreenpopModel
} from 'one-state-screenpop/src/model';

import {
  setAction as screenpopAction
} from 'one-state-screenpop/src/actions';

import {
  ScreenpopModel as ReceiveCommModel
} from 'one-state-receive-communication/src/model';

import {
  setAction as ReceiveCommAction
} from 'one-state-receive-communication/src/actions';

import {
  setAction as addNewFormAction
} from 'one-state-addnew';

import {
  setAction as setSourceType,
  selectAction as selectSourceType,
} from 'one-state-source-type';

import {
  SourceType,
  Skeleton,
} from 'one-model-local';

import {
  ScreenpopComp, HotButtons, DrawerComp
} from 'one-card-drawer';

import {
  MapCard
} from 'one-card-leafletmap';

import {
  AppointmentCard
} from 'one-card-appointments-table';

import {
  addAction as addAppointmentType
} from 'one-state-appointments';
import {
  ActiveAlleriesCard
} from 'one-card-activeallergies';

import {
  ActiveProblemsCard
} from 'one-card-activeproblems';

import {
  MedicalHistoryCard
} from 'one-card-medicalhistory';

import {
  ProviderMatch, NoCall
} from 'one-comp-newcall';
import {
  PatientVerify, NoMatchCall
} from 'one-comp-verifynewpatient';

import {
  OrderTabCard
} from 'one-comp-orderstab'

import {
  ErrorHandlingCard
} from 'one-comp-errorhandling'

import SearchIco from 'one-ui-svg/svg/search.svg';
import NoteIco from 'one-ui-svg/svg/note.svg';
// import UserIco from 'one-ui-svg/svg/user.svg';
import AgentIco from 'one-ui-svg/svg/agent.svg';
import arrowRight from 'one-ui-svg/svg/arrow-right.svg';
import { Image_URL } from 'one-ui-image';
import {
  DownOutlined,
  LogoutOutlined
} from '@ant-design/icons';
// import QuestionIco from 'one-ui-svg/svg/question.svg';

// import {
//   PatientModalCard
// } from 'one-card-patient-modal';

// import {
//   setAction as drawerAction
// } from 'one-state-patient-drawer/src/action';

import {
  setAction as globalSearchAction,
  reinitAction as reinitPatientSearchAction
} from 'one-state-patient-global-search';

import {
  reinitAction as reinitProviderSearchAction
} from 'one-state-provider-global-search';

import {
  PatientGlobalSearchCard
} from 'one-comp-patient-global-search';

// import {
//   ChooseCallerCard
// } from 'one-card-choosecaller';

import {
  //VerifyFlow,
  NewVerifyFlow
} from 'one-card-verifyflow';

import {
  setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
  BillingCard
} from 'one-comp-billing-details';

import {
  selectAction as selectBillingAction,
  setBillingPaymentAction,
} from 'one-state-billing-details';
import {
  InsuranceCard
} from 'one-card-insurance';
// import {
//   InsuranceCardNew
// } from 'one-card-insurance';

import {
  selectAction as selectInsuranceAction
} from 'one-state-insurance';

import {
  //PrescriptionCard,
  PrescriptionTab
} from 'one-card-prescription';

import {
  MedicationCard
} from 'one-comp-medication';
import {
  Version
} from 'one-simulator';
import { adjustHeightWithParams } from 'one-gadget-loader';
//import { medicationstate } from 'one-state-medication';
import {
  healthAlert,
} from '../one-epics/subject/src/index';

import {
  UserIdCard
} from 'one-comp-epicuserid';

import {
  NewUserIdModalCard
} from 'one-comp-newusermodal'

import {
  setPatientSelectedAction,
} from 'one-state-subject/src/actions';

import { 
  PatientMatchType, 
  PatientMatchFrom,
  setMatchTypeAction as setPatientMatchTypeAction, 
  setMatchFromAction as setPatientMatchFromAction
} from 'one-state-patient-match';

import { Disposition } from 'one-model-local';
import ClearTriage from './cleartriage';

import {
  ServiceNowCallerCard
} from 'one-card-sncallermodal';

import {
CallRecord
} from 'one-comp-callrecord'

import {
  IncidentsCard
} from 'one-comp-incidents';

import {
InteractionsCard,
} from 'one-comp-interactions';
import { store } from 'one-state';

import {
  UpdatePVvalue
} from 'one-card-drawer';

import { UserTimeline } from 'one-comp-user-timeline';
import { Icon } from 'antd';
// import {
//   UpdatePVvalue
// } from 'one-card-drawer';

var queryString = require('query-string');

const { TextArea } = Input;
/**
 * Main application UI component
 * @param props - component properties
 */
export const App = (props: any) => {
  const upappts = useSelector((state: any) => (state.upappointments));
  const pendingb = useSelector((state: any) => (state.pendingbill));
  const patients = useSelector((state: any) => (state.subjectstore));
  const entity = useSelector((state: any) => (state.calledentity));
  const referrals = useSelector((state: any) => (state.pendingreferals));
  const source = useSelector((state: any) => (state.sources));
  const sourceType = useSelector((state: any) => (state.sourcetype));
  const pcpstate = useSelector((state: any) => (state.pcpstate));
  const pharmacies = useSelector((state: any) => (state.pharmacy))
  const activetab = useSelector((state: any) => (state.activetab));
  const screenpopstate = useSelector((state: any) => (state.screenpopstate));
  const receivecommunication = useSelector((state: any) => (state.receivecommunicationstate));
  const addnew = useSelector((state: any) => (state.addnew));
  const apptstable = useSelector((state: any) => (state.appointments));
  const allergiesstate = useSelector((state: any) => (state.allergiesstate));
  const activeproblems = useSelector((state: any) => (state.activeproblems));
  const medicalhistory = useSelector((state: any) => (state.medicalhistory));
  const patientglobalsearch = useSelector((state: any) => (state.patientglobalsearch));
  const verify = useSelector((state: any) => (state.patientverify));
  const providerglobalsearch = useSelector((state: any) => (state.providerglobalsearch));
  const errorstate = useSelector((state: any) => (state.errorstate));
  const skeleton = useSelector((state: any) => (state.skeleton));
  const choosecaller = useSelector((state: any) => (state.choosecaller));
  const prescription = useSelector((state: any) => (state.prescription));
  const medication = useSelector((state: any) => (state.medicationdata));
  const orderstabdata = useSelector((state: any) => (state.orderstabledata))
  //const patientdrawer = useSelector((state: any) => (state.patientdrawer));
  const billingdetails = useSelector((state: any) => (state.billingdetails));
  const insurancedetails = useSelector((state: any) => (state.insurancedetails));
  const monitor = useSelector((state: any) => (state.errormonitor));
  const five9InteractionId = useSelector((state: any) => (state.five9Interaction));
  const vonageInteractionId = useSelector((state: any) => (state.vonageInteraction));
  const ccpConnectionData = useSelector((state: any) => (state.ccpInteraction));
  const { active: hasGadgetCall } = useSelector((state: any) => (state.hotkeys));
  const five9Store = useSelector((state: any) => (state.five9Store));
  const five9ClickToDial = useSelector((state: any) => (state.five9ClickToDial));
  const fhirdata = useSelector((state:any) => (state.fhirdetails));
  const epicuserid = useSelector((state:any) => (state.epicuserid));
  const updateuserdata = useSelector((state:any) => (state.updateuserdata))
  const sourcesearchstate = useSelector((state: any) => (state.sourcesearchdata));
  const servicenowinfo = useSelector((state:any) => (state.servicenowcaller));
  const incidentsinfo = useSelector((state:any)=> (state.getincidents));
  const interactionsinfo = useSelector((state:any)=> (state.getinteractions));
  const createinteractionsdata = useSelector((state:any)=> (state.createinteraction));
  const createincidentsdata = useSelector((state:any)=> (state.createincident));
  const updateincidentsdata = useSelector((state:any) => (state.updateincidentstate))
  const linkedincidentdata = useSelector((state:any)=> (state.linkedincident))
  const btgpatientdata = useSelector((state: any) => (state.bgtpatient));
  const patienterror  = useSelector((state:any)=> (state.patientlookuperror));
  const patientMatch = useSelector((state:any)=> (state.patientMatch));
  const setsession = useSelector((state:any)=>(state.setsessionreducer));
  const getsessionresp = useSelector((state:any)=>(state.getsessionreducer));
  const subjectdemo = useSelector((state:any)=>(state.selectedsubjectinfo));
  const { subjectId: five9_subject_id, sourceId: five9_source_id } = useSelector((state: any) => (
    state.five9CallVariables
  ));
  const { interactionId } = useSelector((state: any) => (
    state.five9Interaction
  ));
  const userstate = useSelector((state: any) => (state.userstate));
  const dispositionstate = useSelector((state: any) => (state.dispositionstate));
  const five9LogoutCodes = useSelector((state: any) => (state.five9LogoutCodes));
  const five9UserState = useSelector((state: any) => (state.five9UserState));
  const wxccInteraction = useSelector((state: any) => (state.wxccInteraction));
  const genesysinteraction = useSelector((state:any)=> (state.interactioninfo))
  const genesysagentdata = useSelector((state:any)=> (state.genesysagentinfo))
  const { TabPane } = Tabs;
  const dispatch = useDispatch();
  const { agentId, teamName, settings, resolver, alertnotification, interactionApi, log, static_resource_url } = useCtx();
  const { epicendpoints,compatible, updatepv, screenpop, hotkeys, screenpop_config, uisettings: { confirmappointment, dashboardtab, dashboardapiconfig, dashboardcardconfig, queryparameter, callingdestinationcard,autoscreenpop,autoscreenpop_default_context, simulator, version, tabconfig,btg_config:{btgenable,btgmessage}, sider, drawer, search, card_screenpop_config: { screenpop_config_subjectcard }, uniphore }, soucetypelookup, auth, five9_callvariables, toaster_notification } = settings;
  const {searchID} = epicendpoints;
  const { map: screenpopmap } = screenpop;
  const { map: hotbtnmap} = hotkeys;
  const { patientappointment, getpendingreferrals, getbillingdetails, insurance, activeproblems: activeproblemsCard, medicalhistory: medicalhistoryCard, activeallergies } = dashboardapiconfig;
  const {
    appointments,
    pendingReferrals,
    billingInformation,
    patientCareTeam,
    emergencyContact,
    employmentInformation,
    pharmacies: pharmacyCard,
    insuranceDetails,
    timeline
  } = dashboardcardconfig;
  const { location, apptdesk, referraldesk, pendingbills,pharmacy, nomatchid, event,patientchart } = screenpop_config;
  const { contact_center_type, finesse_gadget_height, utility_menu_width, utility_note_display, agenta_dashboard_icon,screenpop_type,useridtype,  consolidated_api_invocation, sso } = compatible;
  const { kill_all_notification } = toaster_notification;
  const [quickdrawer, setQuickDrawer] = useState(false);
  const [activeallergy, setActiveAllergy] = useState(null);
  const [activeproblem, setActiveProblem] = useState(null);
  const [five9logout, setFive9Logout] = useState(five9Store?.globalsearch);
  const monitorvalue = monitor?.monitor;
  const [widget, setWidget] = useState(true);
  const [tabs, setTabs] = useState("1");
  const [globalpatientselected,setGlobalPatientSelected] = useState<any>({});
  //params hooks for twilio
  const [paramTwilioSid,setParamTwilioSid]=useState("");
  const [paramTwilioAni,setParamTwilioAni]=useState("");
  const [paramTwilioDni,setParamTwilioDni]=useState("");
  const [paramTwilioAgentName,setParamTwilioAgentName]=useState("");

  const  vonage_userId=useSelector((state:any)=>(state.vonageAgentId?.agentId))
  //global search hide fore vonage before agent login
  const vonageGlobalSearch=useSelector((state:any)=>state.vonageUserState?.userStates)
  const { actions } = useSelector((state: any) => (
    state.hotkeys
  ));
  let callType = sessionStorage.getItem("callType")
  let screenpopcounter = Object.keys(receivecommunication).length.toString();
  sessionStorage.setItem("screenpopcounter",screenpopcounter)
  useEffect(()=>{
    if(setsession?.length > 0 ) {
      if(contact_center_type === "finesse") {
        ((updatepv?.sessionkey) && (updatepv?.sessionkey!= "")) && (UpdatePVvalue('sessionkey', setsession[0].created_key, actions, settings, log));
      }
      else if (contact_center_type === "five9") {
        if (contact_center_type && contact_center_type === 'five9') {
          var interactionApi = window.Five9.CrmSdk.interactionApi();
          interactionApi.getCav({interactionId}).then(function (cavList: any) {
            console.log('IframeV4 got cavList: ' + JSON.stringify(cavList));
            let five9sourceid = sessionStorage.getItem("five9_source_id");
            interactionApi.setCav(
              {
                interactionId,
                cavList: [{id: five9_source_id ?  five9_source_id : five9sourceid, name: "sourceid", group: "Caller", type: "STRING", value: setsession[0].created_key}]
              }).then(function (response: any) {
                console.log({setSourceIdCavResponse: response});
                interactionApi.getCav({interactionId}).then(function (cavList: any) {
                  console.log('IframeV5 got cavList: ' + JSON.stringify(cavList));
                })
                //Dispostion Implementation
                let disp: Disposition = { value: "172" }
                disp.dial_list_uid = interactionId;
                let agentIdValue = sessionStorage.getItem("agentName");
                disp.meta00 = agentIdValue;
                disp.meta01 = teamName;
                disp.meta02 = five9_source_id ?  five9_source_id : five9sourceid;
                disp.meta03 = setsession[0].created_key;
                disp.meta04 = 'client';
                dispatch({
                  type: "store-disposition-code",
                  payload: disp
                })
              })
          })
        }
      }
    }
  },[setsession,patients.selected,source.selected])

  useEffect(()=>{
    const sourceTypeSession: SourceType[] = soucetypelookup;
    if(getsessionresp?.length > 0) {
      if (getsessionresp[0]?.lookup_response?.length > 0){
        dispatch({
          type: "caller-patient",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            subjectid: getsessionresp[0].subjectID,
            sourceid: getsessionresp[0].sourceID,
           }
        });
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            visible: false
          }
        });
        //Dispostion for call controls
        let disp: Disposition = { value: "193" }
        disp.dial_list_uid = choosecaller?.callId;
        disp.meta00 = agentId;
        disp.meta01 = teamName;
        disp.meta02 = "";
        disp.meta03 = callType;
        disp.meta04 = choosecaller?.number;
        disp.meta05 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        });
        }
      else {
        //For Subject
        dispatch({
          type: "caller-patient",
          payload: {
            subjectid: getsessionresp[0].subjectID
          }
        });
        //For Source
        dispatch({
          type: "caller-patient",
          payload: {
            sourceid: getsessionresp[0].sourceID
          }
        });
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            visible: false
          }
        });
        // Make patient as verified after selection from patient modal menu
        dispatch({
          type: "one-state-patient-verified/set",
          payload: {
            verified: true,
          }
        });
        dispatch(setSourceType(sourceTypeSession));
        dispatch(selectSourceType(sourceTypeSession[1]));
        dispatch(setPatientMatchTypeAction(PatientMatchType.SINGLE_MATCH));
      }

    }
    else if(getsessionresp?.length === 0) {
      // avoiding lookup api calling when application loads
      const aninumber = sessionStorage.getItem("ani");
      const dninumber = sessionStorage.getItem("dni");

      if(contact_center_type === "vonage" && sessionStorage.getItem('VonageGlobal')==='true' && aninumber?.length>0) {
        dispatch({
          type: "caller-patient",
          payload: {
              number: aninumber,
              dnis: dninumber,
          }
      });
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });

      }
      else if(contact_center_type === "twilio" && paramTwilioAni?.length>0) {
        console.log(choosecaller,"choosecaller2")
        dispatch({
          type: "caller-patient",
          payload: {
              number: paramTwilioAni,
              dnis: paramTwilioDni,
          }
      });

      }

      else if(contact_center_type === "wxcc" && choosecaller?.number) {
        dispatch({
          type: "caller-patient",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis
          }
        });
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
        }
        else if(contact_center_type === "five9" && choosecaller?.number) {
          dispatch({
            type: "caller-patient",
            payload: {
              number: choosecaller.number,
              dnis: choosecaller.dnis
            }
          });
          dispatch({
            type: "getcallerdetails",
            payload: {
              number: choosecaller.number,
              type: "Patient"
            }
          });
        }
        else if(contact_center_type === "genesys" && genesysinteraction?.flowdata) {
          let callerani = "",callerdnis = "";
          if(genesysinteraction.flowdata.participants?.length > 0) {
            if(genesysinteraction.flowdata.participants[0]?.ani?.length === 16) {
              callerani = genesysinteraction.flowdata.participants[0].ani.slice(6);
          }
          if(genesysinteraction.flowdata.participants[0]?.dnis?.length === 16) {
              callerdnis = genesysinteraction.flowdata.participants[0].dnis.slice(6);
          }
          }
            if(callerani?.length > 0) {
              console.log("Lookup call",callerani,callerdnis)
              dispatch({
                type: "caller-patient",
                payload: {
                    number: callerani,
                    dnis: callerdnis,
                }
            });
            dispatch({
              type: "getcallerdetails",
              payload: {
                number: choosecaller.number,
                type: "Patient"
              }
            });
          }
        }
    }
  },[getsessionresp,callType])

  useEffect(() => {
    if(contact_center_type && contact_center_type === 'finesse'){
      // I'm using a 3s timeout here to allow the agentId to make it into the gadget before I make the request.
      setTimeout(() => {
        if (agentId) {
          //startHealthCheck(settings, agentId, settings);
          dispatch({
            type: "healthAlert",
            payload: {
                agentId: agentId,
            }
        });
        }
      }, 5000);
    // This health check hits the Agenta server immediately, as soon as the gadget loads.
    // This will allow us to see if there's a cert issue or a connection issue with the Agenta server.
    }
    if(contact_center_type && contact_center_type === 'vonage'){
      dispatch({
        type: "one-state-getsession/fetch",
        payload: {
            sessionKey:sessionStorage.getItem("vonageInteractionId")
        }
    });
    }
    
  }, []);

  useEffect(() => {
    if(five9Store && five9Store?.globalsearch != five9logout){
      setFive9Logout(five9Store?.globalsearch);
    }
  }, [five9Store]);

  useEffect(()=>{
    if(patients?.selected) {
      dispatch({
        type:"one-state-selectedsubject/set",
        payload: patients?.selected
      })
    }
    if(source?.selected) {
      dispatch({
        type:"one-state-selectedsource/set",
        payload: source?.selected
      })
    }
    if(patients?.selected && source?.selected) {
      if(contact_center_type === 'finesse' || contact_center_type === 'five9') {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "vonage") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:vonageInteractionId?.interactionId,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "twilio") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:paramTwilioSid,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }

      else if(contact_center_type === "wxcc") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:wxccInteraction?.wxccInteractionId,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "genesys") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id: genesysinteraction?.flowdata?.id,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
    }
  },[patients,source])

  /**
   * To check if the PatientLookup API is down
   */
   useEffect(() => {
     //If the patienterror contains the error object.If soit will display a error notification.
    if(patienterror && Object.keys(patienterror).length > 0 && patients.selected === undefined) {
      if(patienterror?.erroritems?.length > 0) {
        patienterror.erroritems.forEach((subjecterror:any)=> {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: "",
            description: subjecterror.display_text,
          });
        })
      }
      else if(patienterror?.status == 500 && patienterror?.erroritems?.length === 0) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 10
        });
        notification['error']({
          message: "",
          description: "Unable to connect to the data server",
        });
      }
    }
  }, [patienterror]);
  
  const globalSelectedPatient = (selectedpatient: any)=> {
    //To check if the consolidaated api is true or false
    if (consolidated_api_invocation) {
      dispatch(setPatientSelectedAction(selectedpatient));
    }
    else {
      sessionStorage.setItem("PatientName",selectedpatient.id);
      dispatch(setSelectedAction(selectedpatient));
    }
    dispatch(reinitPatientSearchAction());
    dispatch({
      type: 'one-state-patient-verified/set',
      payload: {
        verified: true,
      },
    });
    let globalSearchSubjectSelected: Skeleton = {
      upcomingAppts_skeleton: true,
      pendingReferrals_skeleton: true,
      pendingBills_skeleton: true,
      insurance_skeleton: true,
      pendingCare_skeleton: true,
      pharmacies_skeleton: true,
      prescription_skeleton: true,
    };
    dispatch(setSkeletonAction(globalSearchSubjectSelected));
    //Reset the hook after the functtion call.
    setGlobalPatientSelected({})
  }

    //To check whether the Select patient is a BTG patient or not
    useEffect(() => {
      //To Check if we get error for PatientSearch API
      if(Object.keys(btgpatientdata).length > 0 && btgpatientdata?.error && Object.keys(btgpatientdata.error).length > 0 && btgenable) {
        //To check if the erroritems array is present.
        if(btgpatientdata?.error?.erroritems?.length > 0) {
          btgpatientdata.error.erroritems.forEach((errorinfo: any)=> {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 10
            });
            notification['error']({
              message: "",
              description: errorinfo.display_text,
            });
          })
        }
        else if(btgpatientdata?.error?.status == 500 && btgpatientdata?.error?.erroritems?.length === 0) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: "",
            description: "Unable to connect to the data server",
          });
        }
      }
      //Check if the ResourceType is OperationOutcome  then it is a BTG Patient.
      else if(btgpatientdata?.patientbtgdata?.resourceType === "OperationOutcome" && btgenable) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 10
        });
        notification['error']({
          message: "",
          description: btgmessage,
        });
      }
      //If the ResourceType value is Patient then it is a NON-BTG Patient.
      else if (btgpatientdata?.patientbtgdata?.resourceType === "Patient" && btgenable && Object.keys(globalpatientselected && globalpatientselected).length > 0) {
        globalSelectedPatient(globalpatientselected)
      }

    },[btgpatientdata]);

  //Code for Auto-Screenpop
  useEffect(() => {
    /**
     * Checking if a Patient is selected
     * Type of the screenpop in settings file is receive_communication
     * The Autoscreenpop value in the  settings file is true
     */
    if(patients && patients?.selected?.id && screenpop_type === 'receive_communication' && autoscreenpop) {
      // Storing the epicuserid id valiue initially as agentId
      let agentIdValue = agentId;
      //To check for the contact center type and update the  agentIDValue
        if (contact_center_type && contact_center_type === 'five9') {
          //This is for Five9
          agentIdValue = epicuserid?.agentuserid;
        }
        if (contact_center_type && contact_center_type === 'vonage' ) {
          //This is for Vonage
          agentIdValue = epicuserid?.agentuserid;
        }
        if (contact_center_type && contact_center_type === 'twilio' ) {
          //This is for Twilio
          agentIdValue = epicuserid?.agentuserid;
        }
        else if(contact_center_type === "genesys") {
          //This is for Genesys
          agentIdValue = genesysagentdata
        }
        // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
        if (sso === false ) {
          agentIdValue = epicuserid?.agentuserid;
        }
        const patientId = patients?.selected?.id
        const sobject: ReceiveCommModel = {
          //The Context value is the screenpop key 
          context: autoscreenpop_default_context,
          // The selected patients ID
          patientId: patientId ? patientId : "",
          //AgentId is either the epicuserid or agentID based on the  sso value
          agentId: agentIdValue,
          //This value is  configurable (Example value: External)
          useridtype: useridtype,
          // DNIS value
          callId: choosecaller.dnis,
          //Type of Call
          contactType: 'Incoming',
          //Type of Communication
          communicationType: 'Phone',
          //ANI
          phoneNumber: choosecaller?.number,
          //PatientID Type
          type: patientId ? searchID : "",
        }
       //Dispatching for Screenpop
        dispatch(ReceiveCommAction(sobject));
    } 
  },[patients]);

  useEffect(() => {
    if(contact_center_type && contact_center_type === 'finesse') {
      // Fetching information for getepicuserid
      if(agentId) {
        dispatch({
          type: "one-state-getuserid/fetch",
          payload: {
            agentuserid: agentId,
            
          }
        });
       }
    }
    else if(contact_center_type && contact_center_type === 'five9') {
      let agentIdValue = sessionStorage.getItem("five9_userid");
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
     }
     else if(contact_center_type && contact_center_type === 'vonage') {
      let agentIdValue = vonage_userId;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
     }
     else if(contact_center_type && contact_center_type === 'wxcc') {

      let agentIdValue = sessionStorage.getItem("wxcc_userid");

      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
        }
      });
     }
     }
  

  },[]);

  useEffect(()=>{
     if(contact_center_type && contact_center_type === 'twilio') {
      let agentIdValue = paramTwilioAgentName;
      console.log("agentIdValueagentIdValue",agentIdValue)
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
     }
  },[paramTwilioAgentName])

  useEffect(()=>{
    if(contact_center_type && contact_center_type === 'vonage') {
      let agentIdValue = vonage_userId;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
     }
  },[vonage_userId])
 
  useEffect(()=>{
    if(contact_center_type && contact_center_type === 'genesys') {
      let agentIdValue = genesysagentdata;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
     }
  },[genesysagentdata]) 

  /**
   * Show notification for When Agenta Server is down
   */
  useEffect(() => {
    
    if(monitor?.notifiy){
        notification.config({
          placement: "topRight",
          top: 50,
          duration: 0
        });
        const btn = (
          <Button type="primary" size="small">
            <a href={monitor?.healthCheckUrl} target="_blank">Click Here</a>
          </Button>
        );
        notification['error']({
          message: 'Error connecting with Agenta Server. To attempt fixing a certificate error...',
          description: "",
          btn
        });

        dispatch(
          {
            type: "one-state-errorhandle/setnotification",
            payload: {
              notifiy: false
            }
          }
        )
    }
    
  }, [monitor]);

if(queryparameter && contact_center_type!=="twilio") {

  useEffect(() => {
    var searchparameter = queryString.parse(window.location.search);
    
    if(searchparameter) {
      if(searchparameter?.action === "start"){
 
      if(searchparameter?.ani) {
        let skeletondata: Skeleton = {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
      }
  
      dispatch({
          type: "one-state-choosecaller/set",
          payload: {
              number: searchparameter.ani,
              dnis: searchparameter.dnis,
              visible:true,
              start:true
          }
      });
  
  
      dispatch({
          type: "caller-patient",
          payload: {
              number: searchparameter.ani,
              dnis: searchparameter.dnis
          }
      });
      dispatch({
          type: "getcallerdetails",
          payload: {
              number: searchparameter.ani,
              type: "Patient"
          }
      });
      dispatch(setSkeletonAction(
        skeletondata
      ));
      }
    }
    else if(searchparameter?.action === "hangup") {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis
        }
    });

    dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis,
            visible:false,
            start:true
        }
    });

    }
  } 
  else {
    dispatch({
      type: "one-state-subject/reset",
      payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
      }
  });

  dispatch({
      type: "one-state-choosecaller/reset",
      payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible:false,
          start:true
      }
  });
  } 
  }, []);

}
if(queryparameter && contact_center_type==="twilio"){
  var searchparameter = queryString.parse(window.location.search);
  useEffect(()=>{
    setParamTwilioAgentName(searchparameter?.agentName)
    sessionStorage.setItem("twilio_userid",searchparameter?.agentName)
    setParamTwilioAni(searchparameter?.ani)
    // console.log("searchtest",searchparameter)
  if(searchparameter?.action === "start"){
    if(contact_center_type==="twilio"){
      setParamTwilioSid(searchparameter?.sid);
      setParamTwilioDni(searchparameter?.dnis)
      console.log("twilio",searchparameter.sid,paramTwilioSid,paramTwilioAgentName)
      let skeletondata: Skeleton = {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
    }
    dispatch(setSkeletonAction(
      skeletondata
    ));
      dispatch({
        type: "one-state-getsession/fetch",
        payload: {
            sessionKey:searchparameter?.sid
        }
    });
    }

    }
    else if(searchparameter?.action === "hangup") {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis
        }
    });

    dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis,
            visible:false,
            start:true
        }
    });
  
    setParamTwilioAni(null);
    setParamTwilioDni(null);
    setParamTwilioSid(null);
    setParamTwilioAgentName(null)
    sessionStorage.removeItem("twilio_userid")
    }
  
  else {
    dispatch({
      type: "one-state-subject/reset",
      payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
      }
  });

  dispatch({
      type: "one-state-choosecaller/reset",
      payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible:false,
          start:true
      }
  });

  setParamTwilioAni(null);
  setParamTwilioDni(null);
  setParamTwilioSid(null);
  // setParamTwilioAgentName(null)
  // sessionStorage.removeItem("twilio_userid")
  // console.log("searchtesttest1",searchparameter,paramTwilioAgentName)

  }
  },[]);
  useEffect(()=>{
    if(paramTwilioAni?.length>0){
      // console.log("paramTwilioAni",paramTwilioSid,paramTwilioAni,paramTwilioDni)
      dispatch({
        type: "one-state-choosecaller/set",
        payload: {
            number: paramTwilioAni,
            dnis: paramTwilioDni,
            visible:true,
            start:true
        }
    });
  
  
    // dispatch({
    //     type: "caller-patient",
    //     payload: {
    //       number: searchparameter?.ani,
    //       dnis: searchparameter?.dnis,
    //     }
    // });
    dispatch({
        type: "getcallerdetails",
        payload: {
          number: paramTwilioDni,
           type: "Patient"
        }
    });
  }
  },[paramTwilioAni]);
  // console.log("searchtesttest",searchparameter,paramTwilioAgentName,paramTwilioAni)

}

  /**
   *  build he necessary screenpop options and dispatch
   * @param activityId
   */
  const handleScreenPop = (activityId: string, from?: ScreenPopFrom) => {
    const patientContactNumber = patients?.selected?.contact;
    let formattedPhoneNumber = patientContactNumber?.replaceAll('-', '')
    if(screenpop_type === 'snap_adapter'){
      let agentIdValue = agentId;
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = sessionStorage.getItem("five9_userid");
      }
      else if(contact_center_type === "genesys") {
        agentIdValue = genesysagentdata
      }
      const patientid = patients?.selected?.id
      const sobject: ScreenpopModel = {
        activityId,
        patientId: patientid ? patientid : nomatchid,
        eventType: event,
        location,
        agentId: agentIdValue,
        from: from
      }
      dispatch(screenpopAction(sobject));
    }else{
      
      let agentIdValue = agentId;
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = epicuserid?.agentuserid;
      }
      else if(contact_center_type === "genesys") {
        agentIdValue = genesysagentdata
      }
      if (sso === false ) {
        agentIdValue = epicuserid?.agentuserid;
      }
      const patientid = patients?.selected?.id
      //ADPAC-1830
      const sobject: ReceiveCommModel = {
        context: activityId,
        patientId: patientid ? patientid : "",
        agentId: agentIdValue,
        useridtype: useridtype,
        callId: choosecaller.dnis,
        contactType: 'Incoming',
        communicationType: 'Phone',
        phoneNumber: formattedPhoneNumber ? formattedPhoneNumber : choosecaller?.number,
        type: patientid ? searchID : "",
        from: from
      }
      dispatch(ReceiveCommAction(sobject));
    }

  }
  const checkRole = (authdata: any, feature: string, role: string) => {
    if (contact_center_type && contact_center_type === 'five9') {
      //This is for Five9
      role = sessionStorage.getItem("skillName");
    }
    let authorized = true;
    const show = authdata[feature]?.show;
    if ((show) && (show.length > 0)) {
      authorized = (
        show.indexOf(role) !== -1
      );
    }
    if (contact_center_type && contact_center_type === 'vonage') {
       authorized = true;
    }
    return authorized;
  };

  const killNotification = (checked: boolean) => {
      dispatch({
        type: "store-five9-notification",
        payload: checked
      });
  }

  //ADPAC-758
  const cardScreenpopData = (screenpopdata: []) => {
    let data_array: any[] = [];

    screenpopdata.forEach((screenpop_data: any) => {
      let data = {
        id: screenpop_data?.id,
        label: screenpop_data?.label,
        onClick: () => {
          handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
        }
      }
      data_array.push(data);
    })
    return data_array;
  }

  /**
   *  This funciton is called from main dashboard quick cards like appoinements,referal,billing,referals and pharmacies
    *  Build dynamic gear dropdown options based on tab settings which are enable and disable
   * @param enabled
   * @param tabnumber
   * @param screenpoptext
   * @param screenpop
   */
  const buildGearActions = (enabled: boolean, tabnumber: string, screenpoptext: string, screenpop: string, from?: ScreenPopFrom) => {
    let gearJson = [];
    let idincr = "1";
    if (enabled) {
      const moredetails = {
        id: idincr,
        label: 'More Details',
        onClick: () => {
          dispatch(setTabAction(tabnumber));
        }
      }
      gearJson.push(moredetails);
      idincr = "2";
    }
    gearJson.push({
      id: idincr,
      label: screenpoptext,
      onClick: () => {
        handleScreenPop(screenpop, from);
      }
    });
    return gearJson;
  }


   /**
   * Reload the patient information on page reload for Vonage specific agents only
   */
    useEffect(() => {
      if (contact_center_type && contact_center_type === 'vonage') {
        const subjectId = sessionStorage.getItem("subjectid");
        const sourceId = sessionStorage.getItem("sourceid");
        const number = sessionStorage.getItem("ani");
        const dnis = sessionStorage.getItem("dnis");
        const interactionId=sessionStorage.getItem("vonageInteractionId")
  
        let skeleton: {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
        }
        dispatch({
          type: "interact-vonage-set-interaction-id",
          payload: interactionId,
          });
        if (number && dnis && number?.length > 0 && dnis.length > 0) {
          if(consolidated_api_invocation){
            dispatch({
              type: "consolidated-api-one",
              payload: {
                number,
                type: "Patient",
                dnis,
                subjectid: subjectId,
                sourceid: sourceId,
              }
            });
          }else{
            dispatch({
              type: "caller-patient",
              payload: {
                number,
                dnis,
                subjectid: subjectId,
                sourceid: sourceId,
              }
            });
            dispatch({
              type: "getcallerdetails",
              payload: {
                number,
                type: "Patient",
                sourceid: sourceId,
              }
            });
          }
          dispatch({
            type: "one-state-skeleton/set",
            payload: skeleton
          });
        }
      }
    }, []);
  

  /**
   * Reload the patient information on page reload for Five9 specific agents only
   */
  useEffect(() => {
    if (contact_center_type && contact_center_type === 'five9') {
      const subjectId = sessionStorage.getItem("subjectid");
      const sourceId = sessionStorage.getItem("sourceid");
      const number = sessionStorage.getItem("ani");
      const dnis = sessionStorage.getItem("dnis");

      let skeleton: {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
      }
      if (number && dnis && number?.length > 0 && dnis.length > 0) {
        if(consolidated_api_invocation){
          // dispatch({
          //   type: "consolidated-api-one",
          //   payload: {
          //     number,
          //     type: "Patient",
          //     dnis,
          //     subjectid: subjectId,
          //     sourceid: sourceId,
          //   }
          // });
          dispatch({
            type: "one-state-getsession/fetch",
            payload: {
                sessionKey:sourceId ? sourceId.value : null
            }
        });
        }else{
          // dispatch({
          //   type: "caller-patient",
          //   payload: {
          //     number,
          //     dnis,
          //     subjectid: subjectId,
          //     sourceid: sourceId,
          //   }
          // });
          // dispatch({
          //   type: "getcallerdetails",
          //   payload: {
          //     number,
          //     type: "Patient",
          //     sourceid: sourceId,
          //   }
          // });
          dispatch({
            type: "one-state-getsession/fetch",
            payload: {
                sessionKey:sourceId ? sourceId.value : null
            }
        });
        }
        dispatch({
          type: "one-state-skeleton/set",
          payload: skeleton
        });
      }
    }
  }, []);

  /**
   * Reload the patient information on page reload for WxCC specific agents only
   */
  useEffect(() => {
    log.debug('contact_center_type::', contact_center_type);
    if (contact_center_type && contact_center_type === 'wxcc' &&
        wxccInteraction?.taskMap && wxccInteraction?.taskMap?.interactionId &&
        wxccInteraction?.taskMap?.interactionId?.length > 0) {

        const wxccReload = () => {
        log.debug('wxccInteraction?.taskMap::', wxccInteraction?.taskMap);
        const subjectId: any = wxccInteraction?.taskMap?.interaction?.callAssociatedData?.subjectId?.value;
        const sourceId: any = wxccInteraction?.taskMap?.interaction?.callAssociatedData?.sourceId?.value;
        const number: any = wxccInteraction?.taskMap?.interaction?.callAssociatedDetails?.ani;
        const dnis: any = wxccInteraction?.taskMap?.interaction?.callAssociatedDetails?.dn;
        const subjectId_session: any = sessionStorage.getItem("subjectid");
        const sourceId_session: any = sessionStorage.getItem("sourceid");
        log.debug('number:dnis', number, dnis);
        let modelVisible: boolean = true;

        let skeleton: any = {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
        }
        if (number && dnis && number?.length > 0 && dnis.length > 0) {
          if ((subjectId && subjectId !== undefined && subjectId !== 'undefined' && subjectId !== null && subjectId?.length > 0)
            || (sourceId && sourceId !== undefined && sourceId !== 'undefined' && sourceId !== null && sourceId?.length > 0)) {
            modelVisible = false;
          } else if ((subjectId_session && subjectId_session !== undefined && subjectId_session !=='undefined' && subjectId_session !== null && subjectId_session !== 'null' && subjectId_session?.length > 0) ||
            (sourceId_session && sourceId_session !== undefined && sourceId_session !=='undefined' && sourceId_session !== null && sourceId_session !== 'null' && sourceId_session?.length > 0)){
              modelVisible = false;
          }
          dispatch({
            type: "one-state-choosecaller/set",
            payload: {
              number: number,
              dnis: dnis,
              visible: modelVisible,
              start: true,
              callId: wxccInteraction?.taskMap?.interactionId
            }
          });
          if (consolidated_api_invocation) {
            // dispatch({
            //   type: "consolidated-api-one",
            //   payload: {
            //     number,
            //     type: "Patient",
            //     dnis,
            //     subjectid: subjectId ? subjectId : subjectId_session ? subjectId_session : null,
            //     sourceid: sourceId ? sourceId : sourceId_session ? sourceId_session : null,
            //   }
            // });
            dispatch({
              type: "one-state-getsession/fetch",
              payload: {
                  sessionKey:wxccInteraction?.taskMap?.interactionId
              }
          });
          } else {
            // dispatch({
            //   type: "caller-patient",
            //   payload: {
            //     number,
            //     dnis,
            //     subjectid: subjectId ? subjectId : subjectId_session ? subjectId_session : null,
            //     sourceid: sourceId ? sourceId : sourceId_session ? sourceId_session : null,
            //   }
            // });
            // dispatch({
            //   type: "getcallerdetails",
            //   payload: {
            //     number,
            //     type: "Patient",
            //     sourceid: sourceId ? sourceId : sourceId_session ? sourceId_session : null,
            //   }
            // });
            dispatch({
              type: "one-state-getsession/fetch",
              payload: {
                  sessionKey:wxccInteraction?.taskMap?.interactionId
              }
          });
          }
          dispatch({
            type: "one-state-skeleton/set",
            payload: skeleton
          });
        }

      }

      setTimeout(wxccReload, 0)
    }
  }, [wxccInteraction]);

  // To resize to the Finesse Window 
  useEffect(() => {
    try{
        if (contact_center_type && contact_center_type === 'finesse') {
            adjustHeightWithParams(finesse_gadget_height);
        }
      }catch(e){
        console.log('Adjusted Height');
    }
  }, []);

  // This useEffect is specific to demo purpose when we do not get any patient records we display data with 9728918656 ani
  // useEffect(() => {
  //   if (patients && (patients?.values === undefined ? false : true) && patients?.values?.length === 0 && "selected" in patients
  //     && choosecaller && choosecaller?.demo) {
  //     let skeleton: Skeleton = {
  //       source_skeleton: true,
  //       subject_skeleton: true,
  //       callingDestination_skeleton: true
  //     }

  //     dispatch({
  //         type: "one-state-choosecaller/set",
  //         payload: {
  //             number: '9728918656',
  //             dnis: '4698991225',
  //             visible:true,
  //             start:true,
  //             demo: false
  //         }
  //     });


  //     dispatch({
  //         type: "caller-patient",
  //         payload: {
  //             number: '9728918656',
  //             dnis: '4698991225'
  //         }
  //     });
  //     dispatch({
  //         type: "getcallerdetails",
  //         payload: {
  //             number: '9728918656',
  //             type: "Patient"
  //         }
  //     });
  //     dispatch(setSkeletonAction(
  //         skeleton
  //     ));

  //   }
  // }, [patients, choosecaller]);

  /**
   * Open Five9 Widget (if it is minimized), on a new call arrival
   */

  useEffect(() => {
    //Check whether its a new call
    if(five9InteractionId?.interactionId){
      if(five9InteractionId?.interactionId?.length > 0){
        //Change setWidget to true as it is a new call
        setWidget(true);
      }
    }
  },[five9InteractionId]);


  /**
   * Log Dispostion for Incoming call
   */

  useEffect(() => {
    //Check whether if the user state is TALKING
    //console.log('userstate::', userstate);
    //console.log('dispostionstate::', dispositionstate);
    if (userstate?.state === 'TALKING') {
      if (!dispositionstate?.incomingcall) {
        //console.log('Inside::', !dispositionstate?.incomingcall);
        //Dispostion for Incoming call
        let disp: Disposition = { value: "193" }
        disp.dial_list_uid = choosecaller?.callId;
        disp.meta00 = agentId;
        disp.meta01 = teamName;
        disp.meta02 = "";
        disp.meta03 = callType;
        disp.meta04 = choosecaller?.number;
        disp.meta05 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        });
        dispatch({
          type: "set-disposition",
          payload: {
            incomingcall: true
          }
        });
      }
    }
  }, [userstate, dispositionstate]);

  /**
   * Set Five9 Call Variables on Click To Dial 
   */
  useEffect(() => {
    if(five9InteractionId?.interactionId){
      if(five9InteractionId?.interactionId?.length > 0){
        //Check for click to dial is true
        if(five9ClickToDial?.clicktodial){
          if(five9ClickToDial?.type && five9ClickToDial?.type === 'source'){
            var interactionApi = window.Five9.CrmSdk.interactionApi();
            let interactionId = five9InteractionId?.interactionId;
            interactionApi.getCav({interactionId}).then(function (cavList: any) {
            interactionApi.setCav(
                {
                  interactionId,
                  cavList: [{id: five9_source_id, name: "sourceid", group: "Caller", type: "STRING", value: source?.selected?.id}]
                }).then(function (response: any) {
                  interactionApi.getCav({interactionId}).then(function (cavList: any) {
                })
                })
            })
          }
          if(five9ClickToDial?.type && five9ClickToDial?.type === 'subject'){
            var interactionApi = window.Five9.CrmSdk.interactionApi();
            var crmApi = window.Five9.CrmSdk.crmApi();
            let interactionId = five9InteractionId?.interactionId;
            interactionApi.getCav({interactionId}).then(function (cavList: any) {
            interactionApi.setCav(
                {
                  interactionId,
                  cavList: [{id:  five9_subject_id, name: "subjectid", group: "Patient", type: "STRING", value: patients?.selected?.id}]
                }).then(function (response: any) {
                  interactionApi.getCav({interactionId}).then(function (cavList: any) {
                })
                })
            })
            let crmSubjectObject = {id: patients?.selected?.id, label: "Subject", name: patients?.selected?.name, isWho: true, isWhat: false};
            let crmSSNObject = {id: patients?.selected?.ssn, label: "SSN", name: patients?.selected?.ssn, isWho: false, isWhat: true};
            crmApi.objectVisited({crmObject: crmSubjectObject});
            crmApi.objectVisited({crmObject: crmSSNObject});
          }
        }
      }
    }
  }, [five9InteractionId]);


  /**
   * used for screenpop status. as antd notificaiton use hooks internally we are using useeffects
   */
  useEffect(() => {
    if (screenpopstate?.status == 0) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      notification['error']({
        message: screenpopstate.detail ? screenpopstate.detail : "Oops something isn't quite right..! Please make sure you logged into Agenta Snap in Epic Hyperspace",
        description: ""
      });

      if (alertnotification?.isEnabled()) {
        var timestamp = new Date().toJSON();
        alertnotification.notify({
          "error_code": "930-31",
          "error_type": "SERVER_ERROR",
          "error_description": "Unable to reach active servers",
          "error_supertype": "SERVER_FAILS",
          "error_detail": "Unable to reach any of server for retring data ",
          "alert": "Yes",
          "timestamp": timestamp,
          "params": ""
        });
      }

    }
    if (screenpopstate?.status) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (screenpopstate?.status == 200) {
        notification['success']({
          message: 'Epic Screen pop successfully initiated.',
          description: "",
        });
      }
      if (screenpopstate?.status == 500) {
        notification['error']({
          message: 'Screen pop to Epic failed because you are not connected to the Snap Adapter. Please connect and try again.',
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          var timestamp1 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "EPIC Screenpop failed",
            "alert": "Yes",
            "timestamp": timestamp1,
            "params": ""
          });
        }
      }
      else if (screenpopstate?.status > 400) {
        notification['error']({
          message: screenpopstate.detail ? screenpopstate.detail : "Oops something isn't quite right..! Please make sure you logged into Agenta Snap in Epic Hyperspace",
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          var timestamp2 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "Epic Screen pop failed due to a server issue",
            "alert": "Yes",
            "timestamp": timestamp2,
            "params": ""
          });
        }
      }

    }
  }, [screenpopstate]);
  //Update Get epic user id
  useEffect(() => {
    
    if (updateuserdata) {
    //Update Get epic user id
    dispatch({
      type: "one-state-getuserid/set",
      payload: {
        agentuserid: updateuserdata?.updateuserid,
        
      }
    });
    }
    
    //Check whether its a new call
    if(updateuserdata?.status){
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (updateuserdata?.status == 200) {
        notification['success']({
          message: 'User has been successfully registered',
          description: "",
        });
      }
    }
  },[updateuserdata]);

  /**
   * used for screenpop status. as antd notificaiton use hooks internally we are using useeffects
   */
  useEffect(() => {
  
    if (receivecommunication?.output?.success == false) {
      let errorarray = receivecommunication?.output?.error;
      errorarray.forEach((errormsg: any) => {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: errormsg.display_text,
          description: ""
        });
      })

      if (alertnotification?.isEnabled()) {
        var timestamp = new Date().toJSON();
        alertnotification.notify({
          "error_code": "930-31",
          "error_type": "SERVER_ERROR",
          "error_description": "Unable to reach active servers",
          "error_supertype": "SERVER_FAILS",
          "error_detail": "Unable to reach any of server for retring data ",
          "alert": "Yes",
          "timestamp": timestamp,
          "params": ""
        });
      }

    }
    if (receivecommunication?.output) {
      let resultarray = receivecommunication?.output?.success;
      if(resultarray === true) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        if (resultarray === true) {
          notification['success']({
            message: 'Epic Screen pop successfully initiated.',
            description: "",
          });
        }
      }
      
      if (receivecommunication?.output?.status == 500) {
        notification['error']({
          message: 'Screen pop to Epic failed because you are not connected to the Snap Adapter. Please connect and try again.',
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          var timestamp1 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "EPIC Screenpop failed",
            "alert": "Yes",
            "timestamp": timestamp1,
            "params": ""
          });
        }
      }
      else if (receivecommunication?.status > 400) {
        notification['error']({
          message: receivecommunication.detail ? receivecommunication.detail : "Oops something isn't quite right..! Please make sure you logged into Agenta Snap in Epic Hyperspace",
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          var timestamp2 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "Epic Screen pop failed due to a server issue",
            "alert": "Yes",
            "timestamp": timestamp2,
            "params": ""
          });
        }
      }

    }
    if(receivecommunication?.errors?.length > 0) {
        if (receivecommunication?.status > 400) {
          notification['error']({
            message: receivecommunication.errors[0].display_text ? receivecommunication.errors[0].display_text : "Oops something isn't quite right..! Please make sure you logged into Agenta Snap in Epic Hyperspace",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            var timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "EPIC_SCREENPOP_ERROR",
              "error_description": "EPIC Screenpop Initiation failed.",
              "error_supertype": "EPIC_SCREENPOP",
              "error_detail": "Epic Screen pop failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
    }
  }, [receivecommunication]);

   //Check error for SN getcustomerdetails
   useEffect(() => {
     
    if(servicenowinfo?.values?.error) {
      servicenowinfo.values.error.erroritems.map((errorinfo:any)=> {
        if (servicenowinfo?.values?.error?.status > 400) {
          notification['error']({
            message: errorinfo.display_text ? errorinfo.display_text : "Oops something isn't quite right..! Please make sure you logged into Agenta Snap in Epic Hyperspace",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            var timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-CustomerDetails Error",
              "error_description": "SN CustomerDetails Initiation failed.",
              "error_supertype": "SN CustomerDetails",
              "error_detail": "SN CustomerDetails failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
  },[servicenowinfo]);

  //Check for SN createInteractions
  useEffect(() => {
    
    if (createinteractionsdata?.errors?.length > 0) {
      createinteractionsdata.errors.forEach((errorinfo: any) => {
        if (createinteractionsdata?.status > 400) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['error']({
            message: "Failed to create an Interaction",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            var timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-CreateInteractions Error",
              "error_description": "SN CreateInteractions Initiation failed.",
              "error_supertype": "SN CreateInteractions",
              "error_detail": "SN CreateInteractions failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
    else if(createinteractionsdata?.status === 200) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      notification['success']({
        message: 'Interaction has been created successfully.',
        description: "",
      });

    }
  }, [createinteractionsdata]);

    //Check for SN createIncident
    useEffect(() => {
    
      if (createincidentsdata?.errors?.length > 0) {
        createincidentsdata.errors.forEach((errorinfo: any) => {
          if (createincidentsdata?.status > 400) {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 3
            });
            notification['error']({
              message: "Failed to create an Incident",
              description: "",
            });
            //ALERT NOC
            if (alertnotification?.isEnabled()) {
              var timestamp2 = new Date().toJSON();
              alertnotification.notify({
                "error_code": "630-33",
                "error_type": "SN-CreateInteractions Error",
                "error_description": "SN CreateInteractions Initiation failed.",
                "error_supertype": "SN CreateInteractions",
                "error_detail": "SN CreateInteractions failed due to a server issue",
                "alert": "Yes",
                "timestamp": timestamp2,
                "params": ""
              });
            }
          }
        })
      }
      else if(createincidentsdata?.status === 200) {
        if(createincidentsdata?.output?.results?.length > 0) {
          createincidentsdata.output.results.forEach((incidentinfo:any)=> {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 3
            });
            notification['success']({
              message: "Incident:"+incidentinfo.number+"is successfully created.",
              description: "",
            });
          })
        }
      }
    }, [createincidentsdata]);

      //Check for SN Update Incidents
      useEffect(() => {
    
        if (updateincidentsdata?.errors?.length > 0) {
          updateincidentsdata.errors.forEach((errorinfo: any) => {
            if (updateincidentsdata?.status > 400) {
              notification.config({
                placement: "topRight",
                top: 300,
                duration: 3
              });
              notification['error']({
                message: "Failed to update Incident",
                description: "",
              });
              //ALERT NOC
              if (alertnotification?.isEnabled()) {
                var timestamp2 = new Date().toJSON();
                alertnotification.notify({
                  "error_code": "630-33",
                  "error_type": "SN-CreateInteractions Error",
                  "error_description": "SN CreateInteractions Initiation failed.",
                  "error_supertype": "SN CreateInteractions",
                  "error_detail": "SN CreateInteractions failed due to a server issue",
                  "alert": "Yes",
                  "timestamp": timestamp2,
                  "params": ""
                });
              }
            }
          })
        }
        else if(updateincidentsdata?.status === 200) {
          if(updateincidentsdata?.output?.results?.length > 0) {
            updateincidentsdata.output.results.forEach((incidentinfo:any)=> {
              notification.config({
                placement: "topRight",
                top: 300,
                duration: 3
              });
              notification['success']({
                message: "Incidentn is successfully updated.",
                description: "",
              });
            })
          }
        }
      }, [updateincidentsdata]);

  //Check for SN LinkExistingIncident
  useEffect(() => {
    if (linkedincidentdata?.errors?.length > 0) {
      linkedincidentdata.errors.forEach((errorinfo: any) => {
        if (linkedincidentdata?.status > 400) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['error']({
            message: "Failed to link an Incident",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            var timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-LinkIncidents Error",
              "error_description": "SN LinkIncidents Initiation failed.",
              "error_supertype": "SN LinkIncidents",
              "error_detail": "SN LinkIncidents failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
    else if(linkedincidentdata?.status === 200) {
      if(linkedincidentdata?.output?.results?.length > 0) {
        linkedincidentdata.output.results.forEach((incidentinfo:any)=> {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['success']({
            message: "Incident is linked successfully.",
            description: "",
          });
        })
      }
    }
  }, [linkedincidentdata]);

  // check for the allergies and active problems
  useEffect(() => {
    if (allergiesstate?.length > 0) {
      setActiveAllergy(allergiesstate[0].allergenName);
    } else {
      setActiveAllergy(null);
    }
  }, [allergiesstate]);

  useEffect(() => {
    if (activeproblems?.length > 0) {
      setActiveProblem(activeproblems[0].problemName)
    } else {
      setActiveProblem(null);
    }
  }, [activeproblems]);

  /**
   * Show notification for addnew record status
   */

  useEffect(() => {
    if (addnew.notification) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (addnew.notificationmsg === 'Record Inserted Successfully.') {
        notification['success']({
          message: addnew.notificationmsg,
          description: "",
        });
      }
      if (addnew.notificationmsg === 'Caller record was not successfully created.') {
        notification['error']({
          message: addnew.notificationmsg,
          description: "",
        });
      }

    }
  }, [addnew]);

  /**
   * Show notification for Cancel Appointment
   */

  useEffect(() => {
    if (apptstable.cancelmsg) {
      let apptcode = apptstable.apptcode;
      let cancelmsg = apptstable.cancelmsg;
      if (apptcode === '1') {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['success']({
          message: 'Alert',
          description: cancelmsg,
        });
      } else {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Alert',
          description: cancelmsg,
        });
             //making skeleton display before cancelmsg
             dispatch ({
              type: "one-state-skeleton/set",
              payload:{
                  upcomingAppts_skeleton: false,
              }
          })
      }
      dispatch(
        {
          type: "one-state-appointments/reset-cancel-appt-notification",
          payload: {
            cancelmsg: null,
            apptcode: '0'
          }
        }
      )
      if (apptcode === '1') {
        setTimeout(() => {
          dispatch(
            {
              type: "set-appointments-success",
              payload: patients.selected
            }
          )
        }, 1000);
      }
    }
  }, [apptstable]);
  /**
   * identify the caller is provider or patient based on the based state returned
   */
  let patientvaluecount = 0, providervaluecount = 0;
  if (source) {
    const sourcedata = source.values;
    sourcedata.forEach((countvalue: any) => {
      if ((countvalue?.typename) === "Patient") {
        patientvaluecount = patientvaluecount + 1;
      }
      if ((countvalue?.typename) === "Provider") {
        providervaluecount = providervaluecount + 1;
      }
    })
  }

  let dashboardTabWithTimeLine = (
    <Row gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
      <Col span={16}>
        <Row gutter={[16, 16]}>
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <UpcomingAppointmentCard
                    className="box"
                    title="Appointments"
                    gearActions={buildGearActions(tabconfig.appointments, '2', 'Show Appointments in Epic', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                    model={upappts}
                    skeleton={skeleton} />
                </Col>
                <Col span={24}>
                  <PendingBillsCard
                    title="Billing Information"
                    gearActions={buildGearActions(tabconfig.pendingbills, '5', 'Show Guarantor Search in Epic', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingb}
                    skeleton={skeleton} />
                </Col>
                <Col span={24}>
                  <InsuranceCard className='mb-10' title="Insurance" skeleton={skeleton} insurance={insurancedetails} />
                </Col>
              </Row>
          </Col>
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <PendingReferalsCard
                  className="box box-theme2"
                  title="Referrals"
                  gearActions={buildGearActions(tabconfig.referals, '3', 'Show Referrals in Epic', referraldesk, ScreenPopFrom.DASHBOARD_TAB)}
                  model={referrals}
                  colorschema={['#7982B9', '#A5C1DC', '#E9F6FA', '#6050DC']}
                  skeleton={skeleton} />
              </Col>
              <Col span={24}>
                <PharmaciesCard
                  title="Pharmacies"
                  gearActions={buildGearActions(false , '6', 'Show Pharmacies In Epic', pharmacy, ScreenPopFrom.DASHBOARD_TAB)}
                  model={{
                    pharmacydata: pharmacies,
                  }}
                  skeleton={skeleton}
                />
              </Col>
              <Col span={24}>
                <PatientAdditionalInfoCard
                  model={{
                    //TODO: Business Logic must not be sent
                    subjects: patients.values,
                    selected: patients.selected,
                    pcpdata: pcpstate,
                    pharmacydata: pharmacies,
                  }}
                  skeleton={skeleton} />  
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                span={contact_center_type && contact_center_type === 'finesse' ? 24 : null}>
              {dashboardtab.map && (
                <MapCard
                  address={patients.selected?.address}
                  calldest={entity}
                  pharmacies={Object.keys(pharmacies).map((key) => pharmacies[key])}
                  callerNumber={choosecaller?.number || ''} />
              )}
          </Col>
        </Row>
      </Col>
      <Col span={8}>
        <UserTimeline />
      </Col>
    </Row>
  );

  let dashboardTabWithoutTimeLine = (
    <>
      <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
        {
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
            <UpcomingAppointmentCard
              className="box"
              title="Appointments"
              gearActions={buildGearActions(tabconfig.appointments, '2', 'Show Appointments in Epic', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
              model={upappts}
              skeleton={skeleton}
            />
          </Col>
        }
        {
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
            <PendingReferalsCard
              className="box box-theme2"
              title="Pending Referrals"
              gearActions={buildGearActions(tabconfig.referals, '3', 'Show Referrals in Epic', referraldesk, ScreenPopFrom.DASHBOARD_TAB)}
              model={referrals}
              colorschema={['#7982B9', '#A5C1DC', '#E9F6FA', '#6050DC']}
              skeleton={skeleton}
            />
          </Col>
        }
        {
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
            <PendingBillsCard
              title="Billing Information"
              gearActions={buildGearActions(tabconfig.pendingbills, '5', 'Show Guarantor Search in Epic', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
              model={pendingb}
              skeleton={skeleton}
            />
          </Col>
        }
        {
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
            <EmergencyContactCard
              title = 'Emergency Contact'
              model={{
                subjects: patients.values,
                selected: patients.selected
              }}
            />
          </Col>
        }
      </Row>
      <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 64 : { xs: 16, sm: 16, md: 64 }]}>
        <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
              span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
          <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
            <Col span={24}>
              {dashboardtab.map && (
                <MapCard
                  title="Find Location"
                  address={patients.selected?.address}
                  calldest={entity}
                  pharmacies={Object.keys(pharmacies).map((key) => pharmacies[key])}
                  callerNumber={choosecaller?.number || ''}
                />
              )}
            </Col>
          </Row>
        </Col>
        <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
              span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
          <Row type="flex" gutter={[16, 16]}>
            {
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                  sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                  span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <InsuranceCard title="Insurance" skeleton={skeleton} insurance={insurancedetails} />
              </Col>
            }
            {
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                  sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                  span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <PatientCareProviderCard title="Patient Care Team" model={{
                  pcpdata:pcpstate
                }} skeleton={skeleton} />
              </Col>
            }
            {
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                  sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                  span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <EmploymentInfoCard
                  title="Employment Information"
                  model={{
                    //TODO: Business Logic must not be sent
                    subjects: patients.values,
                    selected: patients.selected,
                  }}
                />
              </Col>
            }
            {
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                    sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                    span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <PharmaciesCard
                  title="Pharmacies"
                  gearActions={buildGearActions(false , '6', 'Show Pharmacies In Epic', pharmacy, ScreenPopFrom.DASHBOARD_TAB)}
                  model={{
                    pharmacydata: pharmacies,
                  }}
                  skeleton={skeleton}
                />
              </Col>
            }
          </Row>
        </Col>
      </Row>
    </>
  );
  
  /**
   * Build dashboard based on caller is patient or provider
   * For Patient --Tabs and  Patient Dashboard are shown
   * For Provider -- No tabs ,just new call log with number of matches
   */
  let patientdashboard = (
    <Tabs
      type="line"
      defaultActiveKey="1"
      activeKey={activetab}
      onChange={(activeKey) => dispatch(setTabAction(activeKey))}
    >
      <TabPane tab="Dashboard" key="1">
        {timeline ? dashboardTabWithTimeLine : dashboardTabWithoutTimeLine}
      </TabPane>
      {tabconfig.appointments && checkRole(auth, 'tab/appointments', teamName) && (
        <TabPane tab="Appointments" key="2">
          <AppointmentCard
            title=""
            appointmentType={[
              {
                id: 'future',
                label: 'Future',
              },
              {
                id: 'past',
                label: 'Past',
              },
              {
                id: 'canceled',
                label: 'Canceled',
              },
              {
                id: 'noshows',
                label: 'No Shows',
              },
            ]}
            model={apptstable}
            patientInfo={{
              phone: patients.selected?.contact_formatted,
              address: patients.selected?.address
            }}
            canConfirmAppointment={confirmappointment}
            onAppointmentTypeChange={(value: any) => {
              dispatch(addAppointmentType({ appointmentSelectedType: value }));
            }}
            onCancelAppointment={(value: any) => {
              dispatch({
                type: 'one-state-appointments/cancel-appt',
                payload: value,
              });
            }}
            onConfirmAppointment={(value: any) => {
              dispatch({
                type: 'one-state-appointments/confirm-appt',
                payload: value,
              });
            }}
            onAppointmentScreenpopChange={(value: any) => {
              handleScreenPop(apptdesk, ScreenPopFrom.APPOINTMENTS_TAB);
            }}
          />
        </TabPane>
      )}
      {tabconfig.referals && checkRole(auth, 'tab/referrals', teamName) && (
        <TabPane tab="Referrals" key="3">
          <ReferralsTab
            title="Referal"
            colorschema={[]}
            gearActions={[]}
            model={{
              referalsdata: referrals,
            }}
            handleMenuClick={() => {
              handleScreenPop(referraldesk, ScreenPopFrom.REFERRALS_TAB);
            }}
          />
        </TabPane>
      )}
      {tabconfig.triage && checkRole(auth, 'tab/triage', teamName) && (
        <TabPane tab="Medical History" key="4">
          <Row type="flex" gutter={[16, 32]}>
            {
              (
              <Col span={12}>
                <ActiveProblemsCard
                  title="Active Problems"
                  model={{
                    activeproblems: activeproblems,
                  }}
                />
              </Col>
            )}
            {
              (
              <Col span={12}>
                <MedicalHistoryCard
                  title="Medical History"
                  model={{
                    medicalhistory: medicalhistory,
                  }}
                />
              </Col>
            )}
          </Row>
          <Row type="flex" gutter={[16, 32]}>
            {
              (
              <Col span={24}>
                <ActiveAlleriesCard
                  title="Active Allergies"
                  model={{
                    allergies: allergiesstate,
                  }}
                />
              </Col>
            )}
          </Row>
        </TabPane>
      )}
      {tabconfig.billing && checkRole(auth, 'tab/billing', teamName) && (
        <TabPane tab="Billing" key="5">
          <BillingCard
            title="Outstanding Account"
            billing={billingdetails}
            onAccountChange={(accountevent: any) => {
              dispatch(selectBillingAction(accountevent));
            }}
            onPaymentChange={(billpayment: boolean) => {
              dispatch(setBillingPaymentAction(billpayment));
            }}
          />
        </TabPane>
      )}
      {/* {(tabconfig.pharmacies) &&
        (
          <TabPane tab="Pharmacies" key="6">
          </TabPane>
        )
      } */}

      {tabconfig.prescription && (
        <TabPane tab="Prescription" key="7">
          <PrescriptionTab
            title="Prescription"
            model={{
              prescriptiondata: prescription,
            }}
          />
        </TabPane>
      )}
      {tabconfig.medication && checkRole(auth, 'tab/medication', teamName) && (
        <TabPane tab="Medication" key="8">
          <MedicationCard
            model={{
              medication: medication,
            }}
          />
        </TabPane>
      )}
      {tabconfig.orders && (
        <TabPane tab="Orders" key="9">
          <OrderTabCard
            model={{
              orderdata: orderstabdata?.orderdata,
            }}
          />
        </TabPane>
      )}
      {/* <TabPane tab="Schedule" key="7">
      </TabPane> */}
      {/*<TabPane tab="Location" key="8">
        </TabPane>*/}
      {tabconfig.cleartriage && (
        <TabPane tab="ClearTriage" key="10">
        <Row type="flex" gutter={[16, 32]}>
          <Col span={24}>
            <ClearTriage />
          </Col>
        </Row>
      </TabPane>
      )}   
      {tabconfig.servicenow && (
        <TabPane tab="ServiceNow" key="11">
          <Layout>
            <Row type="flex" gutter={[16, 32]}>
              <Col span={24}>
              <ServiceNowCallerCard
              title='ServiceNow'
              model={{
                servicenowcaller: servicenowinfo
              }}
              skeleton={skeleton}
              />
              </Col>
              <Col span={24}>
                <Tabs
                  defaultActiveKey={tabs}
                  activeKey={tabs}
                  onTabClick={(event: any) => setTabs(event)}
                  type="line"
                  tabBarStyle={{ fontSize: '18px' }}
                >
                  <TabPane
                    tab={<span>Call Record</span>}
                    key="1"
                  >
                    <CallRecord/>
                  </TabPane>
                  <TabPane
                    tab={<span>Incidents</span>}
                    key="2"
                  >
                    <IncidentsCard 
                    title='Incidents'
                    model={{
                      data: incidentsinfo.callerincidentdata
                    }}
                    />
                  </TabPane>
                  <TabPane
                    tab={<span>Interactions</span>}
                    key="3"
                  >
                    <InteractionsCard
                    title=''
                    model={{
                      data:interactionsinfo.callerinteractiondata
                    }}
                    />
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </Layout>
        </TabPane>
      )}
    </Tabs>
  );

  // show only Phone Image on initial screen/ reset
  let dashboard = (
    <NoCall ani={choosecaller?.number} />
  )
  //Checking for Initial Epic User Id
  let epicsuserdata = (
    <>
    {(screenpop_type === 'receive_communication') && (epicuserid?.agentuserid === "") && (sso === false) && (
      <NewUserIdModalCard
      model = {{
        epicuserdata : epicuserid
        }}
      />
    )}
    </>
  )
  //check for the Selected Type
  if (sourceType.selected) {
    let callertype = sourceType.selected?.label;
    // Selected call is Patient
    if (callertype === "Patient") {
      if (patients?.values?.length == 0 &&
        patients?.selected === undefined && getsessionresp?.length === 0) {
        dashboard = (
          <NoMatchCall type="Patient" />
        )
      }
      // Verify Patient ICON to be displayed No patient selected
      else if (patients?.values?.length > 0 &&
        patients?.selected === undefined) {
        dashboard = (
          <PatientVerify onClick={() => {
            // dispatch(drawerAction(true));
            dispatch({
              type: "one-state-choosecaller/set",
              payload: {
                number: choosecaller.number,
                dnis: choosecaller.dnis,
                visible: true,
                start: false
              }
            });
          }} />
        )
      }
      // Display Patient Dashboard
      else if (patients?.values?.length > 0 &&
        patients?.selected !== undefined) {
        dashboard = patientdashboard;
      }

    }
    // Selected call is Provider
    if (callertype === "Provider") {
      // NoMatch Provider Call
      if (source?.values?.length == 0 &&
        source?.selected === undefined && getsessionresp?.length === 0) {
        dashboard = (
          <NoMatchCall type="Provider" />
        )
      }
      // Only Provider
      else if ((providervaluecount > 0 &&
        skeleton.subject_skeleton === false)) {
        dashboard = (
          <ProviderMatch count={providervaluecount} ani={choosecaller?.number} />
        )
      }
      // Display dashboard  if patient selected from the search
      if (patients?.values?.length > 0 &&
        patients?.selected !== undefined) {
        dashboard = patientdashboard;
      }
      else if(subjectdemo) {
        dashboard = patientdashboard;
      }
    }

  } else {
    // considering as no active call.
    if (patients?.values === undefined && source?.values.length == 0) {
      dashboard = (
        <NoCall ani={choosecaller?.number} />
      )
    }
    // No Active call but Display dashboard if patient selected from the global search
    if (patients?.values?.length > 0 &&
      patients?.selected !== undefined) {
      dashboard = patientdashboard;
    }
  }

  const callFive9Logout = (e: any) => {
      log.debug('Inside Logout,', e?.key);
      let five9_userid = sessionStorage.getItem("five9_userid");
      interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${five9_userid}/session_stop?force=true`, method: 'PUT', payload: `{"id":${e?.key}}` }).then(function (result: any) {
        log.debug('Session Stop Executed,', result);
        // resolve handler
        const { status } = result
        log.debug('Session Stop Response Result,', status);
        if(status == 204){
          interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/auth/logout`, method: 'POST', payload: null }).then(function (result: any) {
            log.debug('Logout Executed,', result);
            // resolve handler
            const { status } = result
            log.debug('Logout Result,', status);
            if(status == 204){
              dispatch({
                  type: "one-state-subject/reset",
                  payload: {
                      number: '',
                      dnis: ''
                  }
              });
    
              dispatch({
                  type: "one-state-choosecaller/reset",
                  payload: {
                      number: '',
                      dnis: '',
                      visible: false,
                      start: false
                  }
              });
              dispatch({
                  type: "one-state-tabs/set",
                  payload: "1"
              })
              dispatch({
                  type: "interact-five9-reset",
                  payload: ""
              })
              dispatch({
                type: "store-five9-details-reset",
                payload: ""
              })
              dispatch({
                  type: "store-five9-clicktodial-reset",
                  payload: ""
              })
              dispatch({
                type: "store-five9-user-state-reset",
                payload: ""
              })
              sessionStorage.removeItem("subjectid");
              sessionStorage.removeItem("sourceid");
              //sessionStorage.removeItem("skillName");
              sessionStorage.removeItem("ani");
              sessionStorage.removeItem("dnis");
              sessionStorage.removeItem("agentName");
    
              sessionStorage.removeItem("five9_userid");
              
              sessionStorage.removeItem("five9_subject_id");
              sessionStorage.removeItem("five9_source_id");
              sessionStorage.removeItem("five9_globalsearch");
              sessionStorage.removeItem("five9_user_state");
    
              setFive9Logout(false);
              setTimeout(()=> {
                window.location.reload();
              }, 1500)
            }
    
            
        }, function (error: any) {
            // reject handler
            //log.debug('Call variables error ', error);
            console.log('Five9 Logout', error);
          });
        } else if(status == 435){
          notification.config({
            placement: "topRight",
            top: 50,
            duration: 3
          });
          notification['error']({
            message: "You cannot Logout when you are in Active Call.",
            description: ""
          });
        }
      }, function (error: any) {
          // reject handler
          //log.debug('Call variables error ', error);
          console.log('Five9 Session Stop', error);
      });
      
  }

  const menu = (
    <Menu onClick={callFive9Logout}>
      {
        five9LogoutCodes &&
        five9LogoutCodes?.logoutCodes &&
        five9LogoutCodes?.logoutCodes?.length > 0 &&
        five9LogoutCodes?.logoutCodes?.filter((e: any) => e.selectable === true)?.map((value: any, index: any) => (
        <Menu.Item key={value?.id}>
            {value?.name}
        </Menu.Item>
        ))
      }
    </Menu>
  );

useEffect(()=>{
  if(vonageInteractionId?.interactionId=='' && contact_center_type === 'vonage'){
    dispatch({
      type: "one-state-source/reset",
      payload: {}
     })
  }
  //global search hide before login for vonage
  if(sessionStorage.getItem('VonageGlobal')==='true'){
    dispatch({
      type: "store-vonage-user-state",
      payload: {userStates:true}
  });
  }
},[vonageInteractionId])
  const hasFive9Call = contact_center_type === 'five9' && five9InteractionId?.interactionId && five9InteractionId?.interactionId?.length > 0
  const hasVonageCall = contact_center_type === 'vonage' && vonageInteractionId?.interactionId && vonageInteractionId?.interactionId?.length > 0
  const hasCcpCall = contact_center_type === 'connect' && ccpConnectionData?.connectionId && ccpConnectionData?.connectionId?.length > 0
  const hasTwilioCall = contact_center_type === 'twilio' && paramTwilioAni&&paramTwilioAni?.length > 0
  const hasGenesysCall = contact_center_type === 'genesys' && genesysinteraction?.flowdata && genesysinteraction?.flowdata.id;
  const notactivecall = (patients?.values?.length > 0 ? true : false) || (source?.values?.length > 0 ? true : false) || (choosecaller?.number?.length > 0 ? true : false)
  const hasActiveCall = notactivecall || hasFive9Call || hasCcpCall ||hasVonageCall||hasTwilioCall|| hasGenesysCall || (contact_center_type !== 'five9' && contact_center_type !== 'connect' && contact_center_type !== 'wxcc' && contact_center_type !=='genesys'  &&  consolidated_api_invocation!=='vonage' && hasGadgetCall)
  
  

  let updatepvornot = false;
  let pvarariable = updatepv?.usepv;
  if(pvarariable && pvarariable != "" ) {
    updatepvornot = true;
  }

  const restRequest = (actions: any, options: any,log:any) => {
    if (actions) {
      actions.updatecv(options)
        .catch((e: any) => {
          log.error(
            "one-micro-quickmenu",
            "hotbuttons-restRequest",{
              e
            }
          );
        });
    }
  };

  const updatePV=(actions: any,usepv:any,log:any) =>{
    //get the selected type
    let selected=sessionStorage.getItem("selected");
    let callvar = {
      "name" : usepv,
      "value" : selected
    };
    let callvariable = { "CallVariable" : callvar };
    let mediaProperties = { "callvariables": callvariable };
    var options:any = options || {};
    options.content = {};
    options.content["Dialog"] =
    {
      "mediaProperties": mediaProperties,
      "requestedAction": "UPDATE_CALL_DATA"
    };
    options.method = "PUT";
    options.success = function() {
      //console.log("one-micro-quickmenu ,Call Vars updated successfully");
      log.debug(
        "one-card-hotbutons",
        "hotbuttons-Call Vars updated successfully"
      );
    };
    options.error = function() {
      //console.error("one-micro-quickmenu ,Failed to update call variable");
      log.error(
        "one-card-hotbutons",
        "hotbuttons-Failed to update call variable"
      );
    };
    // Update the variables
    restRequest(actions,options,log);
  };

  const transfer = (actions: any, target: any, usepv:any, updatepvornot:boolean,log:any, type: any, label: any, contact_center_type: any, agentId: any, callId: any, dispatch: any) => {
    if(updatepvornot){
      updatePV(actions,usepv,log);
    }
    if (actions) {
      actions.transfer(target)
        .then((e: any) => {
          //Disposition Framework
          let disp: Disposition = { value: "175" }
          if (contact_center_type && contact_center_type === 'five9') {
            let agentIdValue = sessionStorage.getItem("agentName");
            disp.meta00 = agentIdValue;
          } else {
            disp.meta00 = agentId;
            disp.dial_list_uid = callId;
          }
          disp.meta01 = label;
          disp.meta02 = target;
          disp.meta03 = type;
          disp.meta04 = 'client';
          dispatch({
            type: "store-disposition-code",
            payload: disp
          })
        })
        .catch((excep: any) => {
          log.error(
            "one-card-hotbutons",
            "hotbuttons-transfer", {
            excep
          }
          );
          //Disposition Framework
          let disp: Disposition = { value: "990" }
          if (contact_center_type && contact_center_type === 'five9') {
            let agentIdValue = sessionStorage.getItem("agentName");
            disp.meta00 = agentIdValue;
          } else {
            disp.meta00 = agentId;
            disp.dial_list_uid = callId;
          }
          disp.meta01 = label;
          disp.meta02 = target;
          disp.meta03 = type;
          disp.meta04 = 'client';
          dispatch({
            type: "store-disposition-code",
            payload: disp
          })
        });
    }
  };

  const consult = (actions: any, target: any, usepv:any, updatepvornot:boolean,log:any, type: any, label: any, contact_center_type: any, agentId: any, callId: any, dispatch: any) => {
    if(updatepvornot){
      updatePV(actions,usepv,log);
    }
    if (actions) {
      actions.consult(target)
        .then((e: any) => {
          //Disposition Framework
          let disp: Disposition = { value: "175" }
          if (contact_center_type && contact_center_type === 'five9') {
            let agentIdValue = sessionStorage.getItem("agentName");
            disp.meta00 = agentIdValue;
          } else {
            disp.meta00 = agentId;
            disp.dial_list_uid = callId;
          }
          disp.meta01 = label;
          disp.meta02 = target;
          disp.meta03 = type;
          disp.meta04 = 'client';
          dispatch({
            type: "store-disposition-code",
            payload: disp
          })
        })
        .catch((exe: any) => {
          log.error(
            "one-card-hotbutons",
            "hotbuttons-consult",{
              exe
            }
          );
          //Disposition Framework
          let disp: Disposition = { value: "990" }
          if (contact_center_type && contact_center_type === 'five9') {
            let agentIdValue = sessionStorage.getItem("agentName");
            disp.meta00 = agentIdValue;
          } else {
            disp.meta00 = agentId;
            disp.dial_list_uid = callId;
          }
          disp.meta01 = label;
          disp.meta02 = target;
          disp.meta03 = type;
          disp.meta04 = 'client';
          dispatch({
            type: "store-disposition-code",
            payload: disp
          })
        });
    }
  };

  const navScreenPopBtnGroup = (
    <Menu>
      {screenpopmap.slice(5, screenpopmap.length).map((item: any, index: any) => (
        <Menu.Item>
          <Button size='default' block onClick={
            (item.type === 'web') ?
              (() => { window.open(item.key)} ):
              (() => { handleScreenPop(item.key) })
          }>
            {item.label}
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  );

  const navHotBtnGroup = (
    <Menu>
      {hotbtnmap.map((item: any, index: any) => (
        <Menu.Item>
          <Button size='default' block onClick={
            (item.type === 'blind') ?
              (() => { transfer(actions, item.dn, pvarariable, updatepvornot,log, item.type, item.label, contact_center_type, agentId, choosecaller?.callId, dispatch) }) :
              (() => { consult(actions, item.dn, pvarariable, updatepvornot,log, item.type, item.label, contact_center_type, agentId, choosecaller?.callId, dispatch) })
          }>
            {item.label}
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  );

  const btngroupnavigation = (
    <>
      {
        drawer.screenpop && screenpopmap.slice(0, 5).map((item: any, index: any) => {
          return (
            <Button size='default' style={{margin: '5px 5px'}} onClick={
              (item.type === 'web') ?
                (() => { window.open(item.key)} ):
                (() => { handleScreenPop(item.key) })
            }>
              {item.label}
            </Button>
          )
        })
      }
      {drawer.screenpop && (
        <div style={{paddingRight: '10px', borderRight: '1px solid #e8e8e8'}}>
          <Dropdown placement='bottomRight' trigger={['click']} overlay={navScreenPopBtnGroup}>
            <Button size='default' style={{margin: '5px 5px'}}>
              <Icon type="down" />
            </Button>
          </Dropdown>
        </div>
      )}
      {drawer.hotbuttons && (
        <div style={{paddingLeft: '10px'}}>
          <Dropdown placement='bottomRight' trigger={['click']} overlay={navHotBtnGroup}>
            <Button size='default' style={{margin: '5px 5px'}}>
              Hot Buttons<Icon type="down" />
            </Button>
          </Dropdown>
      </div>
      )}
    </>
  );
  
  return (
    <Layout>
      {(contact_center_type === 'five9' || contact_center_type === 'connect') && (
        <div
          className={contact_center_type === 'five9' ? 'float_five9' : 'float_connect'}
          style={{ display: widget ? 'block' : 'none' }}
        >
          {contact_center_type === 'five9' ? (
            <div><iframe
              src="https://app.five9.com/clients/integrations/adt.main.html?f9crmapi=true&f9verticalthreshold=400px"
              sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms"
              allow="microphone"
              style={{ height: 450 }}
            ></iframe>
            {(contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    (five9Store?.globalsearch ||
                    sessionStorage.getItem("five9_globalsearch") === "true") && five9logout &&
                    (five9UserState?.userSates || sessionStorage.getItem("five9_user_state") === "true")) && (
                <Popover placement="leftBottom" content={menu} trigger="click">
                  <Button style={{ paddingLeft: "27rem", backgroundColor: "#237ba9", marginLeft: "0.625rem" }}>
                    <span style={{ marginLeft: "-25rem", color: "white", fontSize: "medium" }}>Log Out </span>
                  </Button>
                </Popover>
                )}
            </div>
          ) : (
            <div id="containerDiv" style={{ height: 450 }}></div>
          )}
        </div>
      )}
      <Header>
        <HeaderBar
          topnavigation={
            <>
              <TopNavigation>
                <NavigationItem type="logo">
                  {(hasActiveCall) && (<img
                    src={Image_URL(resolver(logo), `${static_resource_url}logo.e26843c7.png`)}
                    alt={'SpinSci'}
                    draggable="false"
                    onClick={(e) => {
                      dispatch(setTabAction('1'));
                    }}
                    style={{cursor: 'pointer'}}
                  />)}
                  {(!hasActiveCall) && (<img
                    src={Image_URL(resolver(logo), `${static_resource_url}logo.e26843c7.png`)}
                    alt={'SpinSci'}
                    draggable="false"
                  />)}
                  {/* <UserIdCard 
                    model = {{epicuserdata : epicuserid}} 
                    className='nav-change-user-epic-btn'
                    style={{marginBottom: '0px', marginLeft: '5px'}}  
                  /> */}
                </NavigationItem>
                {/* <NavigationItem label="Total" value="78" /> */}
              </TopNavigation>
            </>
          }
          //btngroupnavigation={btngroupnavigation}
          usernavigation={
            <>
              <UserNavigation>
              {(contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    five9Store?.globalsearch &&
                    kill_all_notification) && (
                  <UserNavigationItem>
                    <Switch defaultChecked onChange={killNotification} />
                  </UserNavigationItem>
                )}
                <UserNavigationItem>
                  {((contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    (five9Store?.globalsearch ||
                    sessionStorage.getItem("five9_globalsearch") === "true") && five9logout) ||
                    (contact_center_type && contact_center_type === 'finesse') ||
                    (contact_center_type && contact_center_type === 'connect')|| (contact_center_type && contact_center_type === 'wxcc') || (contact_center_type && contact_center_type === 'vonage' && vonageGlobalSearch) ||
                    (contact_center_type && contact_center_type === 'twilio') || (contact_center_type && contact_center_type === 'genesys')) && (
                    <a

                      className="user-navigation__btn"
                      onClick={(e) => {
                        (search.patient || search.provider) && dispatch(globalSearchAction(true));
                        dispatch(setPatientMatchFromAction(PatientMatchFrom.GLOBAL_SEARCH));
                      }}
                    >
                      <Tooltip title="Search">
                        <img src={Image_URL(resolver(SearchIco), `${static_resource_url}search.c969bcf6.svg`)} width={17}  draggable="false" />
                      </Tooltip>
                    </a>
                  )}
                  <PatientGlobalSearchCard
                    title="Search"
                    model={patientglobalsearch}
                    providermodel={providerglobalsearch}
                    onRowClick={(searchevent: any) => {
                       //Reset the error reducer
                      dispatch({
                        type:"one-state-error/reinit"
                      })
                      if (sourcesearchstate.show) {
                        let providersearchdata = patientglobalsearch?.data;
                        const sourceTypeForGlobalSearch: SourceType[] = soucetypelookup;
                        let indexval = providersearchdata.findIndex(
                          (prodetails: any) => prodetails.mrn === searchevent.mrn
                        );
                        let profound = false;

                        if (source?.values?.length > 0) {
                          let providersearchval = source?.values;
                          if (providersearchval && providersearchval.length > 0) {
                            providersearchval.forEach((providerdata: any) => {
                              if (providerdata?.id == searchevent?.mrn) {
                                profound = true;
                              }
                            });
                          }
                        }

                        if (!profound) {
                          dispatch(addSourceAction(providersearchdata[indexval]));
                          dispatch(addSubjectAction(providersearchdata[indexval]));
                        }
                        dispatch(setSourceType(sourceTypeForGlobalSearch));
                        dispatch(selectSourceType(sourceTypeForGlobalSearch[1]));
                        dispatch(reinitProviderSearchAction());
                        dispatch(reinitPatientSearchAction());
                        dispatch(globalSearchAction(false));
                        dispatch(selectAction(searchevent?.mrn));
                        dispatch({
                          type: 'one-state-choosecaller/set',
                          payload: {
                            number: choosecaller.number,
                            dnis: choosecaller.dnis,
                            visible: true,
                            start: false,
                            type: 'patient',
                          },
                        });
                      } else {
                        // for disposition matching type
                        let disp: Disposition = { value: "" };
                        if (patientMatch.matchFrom === PatientMatchFrom.GLOBAL_SEARCH) {
                          dispatch(setPatientMatchTypeAction(PatientMatchType.GLOBAL_MATCH));
                          disp.value = '2004';
                          disp.meta00 = agentId;
                          disp.meta01 = teamName;
                          disp.meta02 = searchevent.mrn;
                          disp.meta03 = choosecaller?.number
                        } else {
                          if (patients?.values?.length > 0) { // mis match
                            dispatch(setPatientMatchTypeAction(PatientMatchType.MIS_MATCH));
                            disp.value = '2003';
                            disp.meta00 = agentId;
                            disp.meta01 = teamName;
                            disp.meta02 = searchevent.mrn;
                            disp.meta03 = choosecaller?.number
                          } else { // no match
                            dispatch(setPatientMatchTypeAction(PatientMatchType.NO_MATCH));
                            disp.value = '2002';
                            disp.meta00 = agentId;
                            disp.meta01 = teamName;
                            disp.meta02 = searchevent.mrn;
                            disp.meta03 = choosecaller?.number
                          }
                        }
                        dispatch({
                          type: "store-disposition-code",
                          payload: disp
                        });

                        let patientsearchdata = patientglobalsearch?.data;
                        let indexvalue = patientsearchdata.findIndex(
                          (pdetails: any) => pdetails.mrn === searchevent.mrn
                        );
                        let found = false;
                        if (patients?.values?.length > 0) {
                          let patientsearchval = patients?.values;
                          if (patientsearchval && patientsearchval.length > 0) {
                            patientsearchval.forEach((patientdata: any) => {
                              if (patientdata?.mrn == searchevent?.mrn) {
                                found = true;
                              }
                            });
                          }
                        }

                        if (!found) {
                          dispatch(addSubjectAction(patientsearchdata[indexvalue]));
                        }
                          if(btgenable) {
                            dispatch({
                              type: "one-state-btgpatient/fetch",
                              payload: {
                                name: patientsearchdata[indexvalue].lastname,
                                dob: patientsearchdata[indexvalue].dob,
                                given: patientsearchdata[indexvalue].firstname,
                                identifier: patientsearchdata[indexvalue].id,
                                telecom: patientsearchdata[indexvalue].contact
                              }
                            })
                            setGlobalPatientSelected(patientsearchdata[indexvalue]);
                          }
                          else {
                            globalSelectedPatient(patientsearchdata[indexvalue])
                          }
                      }
                    }}
                    onProviderRowClick={(providersearchevent: any) => {
                      let providersearchdata = providerglobalsearch?.data;
                      const sourceTypeForGlobalSearch: SourceType[] = soucetypelookup;
                      let indexval = providersearchdata.findIndex(
                        (prodetails: any) => prodetails.id === providersearchevent
                      );
                      let profound = false;
                      if (source?.values?.length > 0) {
                        let providersearchval = source?.values;
                        if (providersearchval && providersearchval.length > 0) {
                          providersearchval.forEach((providerdata: any) => {
                            if (providerdata?.id == providersearchevent) {
                              profound = true;
                            }
                          });
                        }
                      }
                      if (!profound) {
                        const payload = {
                          ...providersearchdata[indexval],
                          contact_formatted: providersearchdata[indexval].contact
                        }
                        dispatch(addSourceAction(payload));
                      }
                      dispatch(setSourceType(sourceTypeForGlobalSearch));
                      dispatch(selectSourceType(sourceTypeForGlobalSearch[1]));
                      dispatch(reinitProviderSearchAction());
                      dispatch(globalSearchAction(false));
                      dispatch(selectAction(providersearchevent));
                    }}
                  />
                </UserNavigationItem>
                {!monitorvalue && (
                  <UserNavigationItem>
                    <a className="user-navigation__btn">
                      <ErrorHandlingCard />
                    </a>
                  </UserNavigationItem>
                )}

                {((contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    (five9Store?.globalsearch ||
                    sessionStorage.getItem("five9_globalsearch") === "true") && five9logout) ||
                    (contact_center_type && contact_center_type === 'finesse') ||
                    (contact_center_type && contact_center_type === 'connect') 
                    || (contact_center_type && contact_center_type === 'wxcc') || (contact_center_type && contact_center_type === 'vonage')
                    ||(contact_center_type && contact_center_type === 'twilio') || (contact_center_type && contact_center_type === "genesys")) && (<UserNavigationItem>
                  <a
                    className={`user-navigation__btn user-navigation__btn--box state--active`}
                    onClick={(e) => {
                      setQuickDrawer(true);
                    }}
                  >
                    <Tooltip title="Quick Menu" placement="bottomRight">
                      <img src={Image_URL(resolver(NoteIco), `${static_resource_url}note.4b2bcf64.svg`)} width={17}  draggable="false"/>
                    </Tooltip>
                  </a>
                </UserNavigationItem>
                )}
                {/* {(contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    (five9Store?.globalsearch ||
                    sessionStorage.getItem("five9_globalsearch") === "true") && five9logout) && (<UserNavigationItem>
                  <a
                    className={`user-navigation__btn user-navigation__btn--box state--active`}
                  >
                    <Dropdown overlay={menu}>
                      <Button>
                        <LogoutOutlined/>
                      </Button>
                    </Dropdown>
                  </a>
                </UserNavigationItem>)} */}
                {/* user Icon Disabled for now */}
                {/* <UserNavigationItem>
                  <a className="user-navigation__btn user-navigation__btn--user">

                    <Icon component={resolver(UserIco)} style={{color: "red", fill: "red"}} />
                    <Tooltip title="User">
                    <img
                      src={resolver(UserIco)}
                      width={17}
                      style={{ fill: "#bdbdbd" }}
                    />
                  </Tooltip>
                  </a>
                </UserNavigationItem> */}
              </UserNavigation>
            </>
          }
        />
        
        <DrawerComp
          closable={true}
          width={'295px'}
          visible={quickdrawer}
          title="Quick Menu"
          onClose={(event1) => {
            setQuickDrawer(false);
          }}
        >
          <>
          {(screenpop_type === 'receive_communication') && (
            <UserIdCard
            model = {{
            epicuserdata : epicuserid
            }}
            />
          )}
          
            <a
              className="ant-drawer__close"
              onClick={(e) => {
                setQuickDrawer(false);
              }}
            >
              
              {' '}
              <img src={Image_URL(resolver(arrowRight), `${static_resource_url}arrow-right.9dade3ae.svg`)} width={6} height={10} style={{ fill: '#bdbdbd' }}  draggable="false"/>
            </a>
            {drawer?.screenpop && <ScreenpopComp selected={patients.selected} ani={choosecaller?.number} dnis={choosecaller?.dnis}/>}
            {drawer?.hotbuttons && <HotButtons />}
          </>
        </DrawerComp>
      </Header>
      <Layout>
        {widget && sider && contact_center_type!=="twilio"&& (
          <Sider width={utility_menu_width} className="content-sider">
            {/* <Tabs type="card" tabBarGutter={0} className="ant-tabs--sidebar"> */}
            {/* {(utility_note_display) && (<TabPane tab="         Utility          " key="1"> */}
            {/* <div className="guide"> */}
            {/* <div className="guide__aside"> */}
            {/* <TextArea rows={6} placeholder={"Got any notes?"} >
                   </TextArea>
                  <Divider /> */}

            {/* </div> */}
            {/* </div> */}

            {/* </TabPane>)} */}

            {/* </Tabs> */}
          </Sider>
        )}
        <Content>
          <ContentBox style={{maxWidth: uniphore ? '100%' : '124rem'}}>
            <NewVerifyFlow
              model={{
                source: source,
                subjects: patients.values,
                subjectselcted: patients?.selected,
                choosecaller: choosecaller,
              }}
              skeleton={skeleton}
            />
            {/* Remove PatientModalCard for ADPAC-489,ADPAC-490  */}
            {hasActiveCall && (
              <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
                  <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                       md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                       span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  {/* Replace SourceCard for ADPAC-489,ADPAC-490 */}
                  <SourceCardSimple
                    title="Source"
                    source={source}
                    type={sourceType}
                    sourcePath={source?.selected?.id === patients?.selected?.id ? 'patient' : ''}
                    gearActions={[
                      {
                        id: '1',
                        label: 'Add New Source',
                        onClick: () => {
                          dispatch(
                            addNewFormAction({
                              value: true,
                            })
                          );
                        },
                      },
                    ]}
                    onSourceChange={(value) => {
                      //TODO: Make it type safe.
                      // const selected = source?.values?.find(
                      //   (item: any) => item.id === value
                      // );
                      // dispatch(
                      //   selectAction(selected?.id)
                      // )
                    }}
                    onSourceTypeChange={(value: any) => {
                      //TODO: Make it type safe.
                      // const type: SourceType = sourceType?.values?.find(
                      //   (item: any) => item.id === value
                      // );
                      // dispatch(
                      //   selectSourceType(type)
                      // )
                    }}
                    onAddNewChange={(value: any) => {
                      dispatch(
                        addNewFormAction({
                          value: value,
                        })
                      );
                    }}
                    verifySource={() => {
                      if (source?.values.length > 0) {
                        dispatch({
                          type: 'one-state-choosecaller/set',
                          payload: {
                            number: choosecaller.number,
                            dnis: choosecaller.dnis,
                            visible: true,
                            start: false,
                            type: 'provider',
                            clicked: true,
                          },
                        });
                      }
                    }}
                    skeleton={skeleton}
                    patientcount={patients?.values?.length}
                  />
                  <AddNewFormEnable value={addnew} choosecaller={choosecaller} />
                </Col>
                <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                     md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                     span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  <SubjectCard
                    title="Subject"
                    gearActions={cardScreenpopData(screenpop_config_subjectcard)}
                    onPatientScreenpopChange={(value: any) => {
                      handleScreenPop(patientchart);
                    }}
                    model={{
                      subjects: patients.values,
                      selected: patients.selected,
                    }}
                    verified={verify?.verified}
                    onSubjectChange={(value) => {
                      let subjectCardOnChangeSkeleton: Skeleton = {
                        upcomingAppts_skeleton: true,
                        pendingReferrals_skeleton: true,
                        pendingBills_skeleton: true,
                        insurance_skeleton: true,
                        pendingCare_skeleton: true,
                        pharmacies_skeleton: true,
                        prescription_skeleton: true,
                      };
                      const selected = patients.values.find((patient: any) => patient.id === value);
                      dispatch(setSelectedAction(selected));
                      dispatch(setSkeletonAction(subjectCardOnChangeSkeleton));
                    }}
                    onClick={() => {
                      if (patients?.values.length > 0) {
                        dispatch({
                          type: 'one-state-choosecaller/set',
                          payload: {
                            number: choosecaller.number,
                            dnis: choosecaller.dnis,
                            visible: true,
                            start: false,
                            type: 'patient',
                            clicked: true,
                          },
                        });
                      }
                    }}
                    skeleton={skeleton}
                    allergy={activeallergy}
                    activeprob={activeproblem}
                    pediatricage={dashboardtab?.pediatricage}
                  />
                </Col>
              </Row>
            )}
            {hasActiveCall && callingdestinationcard && (
              <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
                <Col span={24}>
                  <CallDestCard
                    title="Calling Destination"
                    note={entity.calltype}
                    model={{
                      callingdest: entity,
                    }}
                    onClick={() => {
                      dispatch(setTabAction('8'));
                    }}
                    skeleton={skeleton}
                  />
                </Col>
              </Row>
            )}
            {dashboard}
            {epicsuserdata}
          </ContentBox>
        </Content>
      </Layout>
      <Footer>
        <Affix offsetBottom={0}>
          <FooterBox
            mainblock={
              <>
                {agenta_dashboard_icon && (
                  <Button
                    className="ant-btn--ghost"
                    ghost
                    onClick={() => {
                      setWidget(!widget);
                    }}
                  >
                    <img src={resolver(AgentIco)} width={14} height={18} style={{ marginRight: '8px' }} draggable="false" />
                    Agent Dashboard
                  </Button>
                )}

                {simulator && <CallSelection />}
                {/* //versioning for vonage */}

                {version && <Version versionWidth={ contact_center_type && contact_center_type === 'finesse' ? '1242px' : '1105px' } versionShow={(contact_center_type==='vonage'|| contact_center_type==='twilio')?false:true}/>}
              </>
            }
            sideblock={
              <>
                {/* <FooterAsideItem >
                  Tab 1
            </FooterAsideItem>
                <FooterAsideItem >
                  Tab 2
               </FooterAsideItem>*/}
                <FooterAsideItem>
                  {(source.values.length > 0 || patients.values) && (
                    <NotifyCard
                      title="notify"
                      model={{
                        errorobject: errorstate?.values,
                      }}
                    />
                  )}
                </FooterAsideItem>
              </>
            }
          />
        </Affix>
      </Footer>
    </Layout>
  );
};
